import { FC, memo, useEffect, useState } from 'react'

import PortalRootsContext, { initialState } from '~context/portalRootsContext'
import { PortalRoots } from '~lib/constants'

const PortalRootsProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [roots, setRoots] = useState(initialState)

  useEffect(() => {
    setRoots({
      modalRoot: document.getElementById(PortalRoots.MODAL_ROOT),
      popupRoot: document.getElementById(PortalRoots.POPUP_ROOT),
      tooltipRoot: document.getElementById(PortalRoots.TOOLTIP_ROOT),
    })
  }, [])

  return <PortalRootsContext.Provider value={roots}>{children}</PortalRootsContext.Provider>
}

// upcast to FC to prevent error in app.js related to component type
export default memo(PortalRootsProvider) as FC<React.PropsWithChildren<Record<string, unknown>>>
